var partition = function (arr, fn) {
    return arr.reduce(function (acc, val, i, arr) {
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [[], []]);
};
export default partition;
